<template>
  <div>
    <h5>Available for the following locations:</h5>
    <div>
      <input
        style="z-index: 999999 !important; width: 100% !important"
        class="location-input-background form-control"
        :placeholder="myPlaceholder"
        id="myinput"
      />
    </div>

    <div id="countriesSwiper" class="swiper-container">
      <div class="swiper-wrapper">
        <div
          v-for="location in dogWalkingProfile.Areas"
          class="animated fadeInRight swiper-slide label label-info"
        >
          {{ location.AreaName }}
          <button
            type="button"
            @click="removeLocation(location)"
            style="position: absolute; right: 5px; top: 5px"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
    <!--end of countriesSwiper-->
    <hr style="margin-top: 10px" />
    <h5>Available on the following days:</h5>

    <label style="margin-left: 10px" class="small checkbox-inline">
      <input type="checkbox" v-model="allDays" /><span class="small"
        >All Days</span
      >
    </label>

    <label class="small checkbox-inline">
      <input
        type="checkbox"
        :disabled="allDays"
        v-model="sun"
        true-value="1"
        false-value="0"
      /><span class="small">Sun</span>
    </label>

    <label class="small checkbox-inline">
      <input
        type="checkbox"
        :disabled="allDays"
        v-model="mon"
        true-value="2"
        false-value="0"
      /><span class="small">Mon</span>
    </label>

    <label class="small checkbox-inline">
      <input
        type="checkbox"
        :disabled="allDays"
        v-model="tue"
        true-value="4"
        false-value="0"
      /><span class="small">Tue</span>
    </label>

    <label class="small checkbox-inline">
      <input
        type="checkbox"
        :disabled="allDays"
        v-model="wed"
        true-value="8"
        false-value="0"
      /><span class="small">Wed</span>
    </label>

    <label class="small checkbox-inline">
      <input
        type="checkbox"
        :disabled="allDays"
        v-model="thu"
        true-value="16"
        false-value="0"
      /><span class="small">Thu</span>
    </label>

    <label class="small checkbox-inline">
      <input
        type="checkbox"
        :disabled="allDays"
        v-model="fri"
        true-value="32"
        false-value="0"
      /><span class="small">Fri</span>
    </label>

    <label class="small checkbox-inline">
      <input
        type="checkbox"
        :disabled="allDays"
        v-model="sat"
        true-value="64"
        false-value="0"
      /><span class="small">Sat</span>
    </label>

    <hr />
    <h5>Availability time and restrictions:</h5>
    <textarea
      v-model="dogWalkingProfile.Remarks"
      class="form-control"
      type="text"
      rows="5"
      placeholder="i.e I am only available from 5:00 PM to 7:00 PM, 9:00 AM to 10:00 AM on JLT"
    >
    </textarea>

    <br />

    <button
      style="margin-left: 10px"
      class="pull-right btn btn-warning"
      data-dismiss="modal"
    >
      Close
    </button>
    <button class="pull-right btn btn-success" @click="saveChanges()">
      Save Changes
    </button>
    <br />
    <br />
  </div>
</template>

<script>
import Vue from "vue";
import sitterApi from "../../../services/sitterApi";
import router from "../../../router";
import auth from "../../../auth";
import store from "../../../data/store";
import commonApi from "../../../services/commonApi";

import Swiper from "swiper";

import Awesomplete from "awesomplete";

require("swiper/dist/css/swiper.min.css");
require("awesomplete/awesomplete.css");

export default {
  name: "dogwalking",
  props: ["cityId"],
  components: {},

  data() {
    return {
      dogWalkingProfile: "",
      myPlaceholder: "Add location or multiple locations",
      allDays: false,
      days: 0,
      sun: 0,
      mon: 0,
      tue: 0,
      wed: 0,
      thu: 0,
      fri: 0,
      sat: 0,
    };
  },
  watch: {},
  update: function () {},
  created() {},
  methods: {
    saveChanges: function () {
      var self = this;
      if (this.allDays == true) self.dogWalkingProfile.DaysOfWeek = 127;
      else {
        self.dogWalkingProfile.DaysOfWeek =
          this.sun |
          this.mon |
          this.tue |
          this.wed |
          this.thu |
          this.fri |
          this.sat;
      }

      var self = this;
      $.ajax({
        type: "POST",
        data: JSON.stringify(self.dogWalkingProfile),
        url: "https://www.dupaws.com/services/api/dogWalkingProfile/",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (data) {
          console.log("success saving post");
          $("#dogWalkingModal").modal("hide");
        },
        error: function (data, status, error) {
          try {
          } catch (e) {}
        },
      });
    },
    removeLocation: function (location) {
      var self = this;
      const index = self.dogWalkingProfile.Areas.findIndex(
        (t) => t.AreaId === location.AreaId
      );
      self.dogWalkingProfile.Areas.splice(index, 1);
    },
    getDogWalkingProfile: function () {
      var self = this;
      $.ajax({
        type: "GET",
        url: "https://www.dupaws.com/services/api/dogWalkingProfile/",
        beforeSend: function (xhr) {
          xhr.setRequestHeader(
            "Authorization",
            "bearer " + localStorage.getItem("access_token")
          );
        },
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (data) {
          self.dogWalkingProfile = data;
          if (data.DaysOfWeek == 127) {
            self.allDays = true;
          }
          self.sun = data.DaysOfWeek & 1;
          self.mon = data.DaysOfWeek & 2;
          self.tue = data.DaysOfWeek & 4;
          self.wed = data.DaysOfWeek & 8;
          self.thu = data.DaysOfWeek & 16;
          self.fri = data.DaysOfWeek & 32;
          self.sat = data.DaysOfWeek & 64;
        },
        error: function (data, status, error) {
          try {
          } catch (e) {}
        },
      });
    },
  },
  mounted: function () {
    var self = this;

    this.$ga.page(this.$router);
    self.getDogWalkingProfile();
    commonApi.getAreasList(self.cityId).done(function () {
      console.log("success areas list");
      var input = document.getElementById("myinput");
      new Awesomplete(input, {
        minChars: 1,
        maxItems: 15,
        autoFirst: true,
        list: self.areasList,
        replace: function (suggestion) {
          //used to change value to label, stupid bug.
          this.input.value = "";
        },
        data: function (item, input) {
          return { label: item.AreaName, value: item.AreaId };
        },
      });
      input.addEventListener("awesomplete-select", function (item) {
        var newArea = { AreaName: item.text.label, AreaId: item.text.value };
        if (self.dogWalkingProfile.Areas.length < 5)
          self.dogWalkingProfile.Areas.push(newArea);
        else {
          swal("Info", "Maximum number of areas you can add is 5", "info");
        }
        // self.dogWalkingProfile.Areas.push(item)
      });
    });

    if (!store.getters.authenticated && !localStorage.getItem("access_token")) {
      router.router.push({
        path: "/login",
        query: { redirect: "sitterprofile/about" },
      });
    }

    var countriesSwiper = new Swiper("#countriesSwiper", {
      spaceBetween: 30,
      slidesPerView: "auto",

      observer: true,
      observeParents: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        // when window width is <= 480px
        480: {
          slidesPerView: "auto",
          spaceBetween: 20,
          width: 300,
        },
        // when window width is <= 640px
        640: {
          slidesPerView: "auto",
          spaceBetween: 30,
          width: 480,
        },
      },
    });
  },
  computed: {
    areasList: function () {
      return store.getters.AreasList;
    },
  },
};
</script>

<style scoped>
.location-input-background {
  background: url(../images/location.svg) no-repeat scroll 7px 7px;
  background-size: 10px;
  padding-left: 30px;
  padding-top: 4px;
  background-size: 19px;
  background-color: white;
}

.alert-dismissible .close {
  padding: 5px;
}

.swiper-slide {
  padding: 5px;
  padding-top: 10px;
  border: 1px #d8d5d5;
  border-style: solid;
  width: 80%;
  height: 33px;
}

.swiper-container {
  max-height: 50px;
  margin-top: 10px;
  z-index: auto !important; /*fixes z-index:1 issue where swiper overrides tooltips or other components*/
  padding: 0px;
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.13);
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.13);
}

.swiper-container .swiper-wrapper .swiper-slide {
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.13);
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.13);
}

.swiper-wrapper {
  z-index: auto !important;
}

.awesomplete {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// DogWalking.vue?8a8cc91e